import { useParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import InvestigateTimeline from "@/components/InvestigateTimeline";

// Investigate, one session (docs/INVESTIGATE_PLAN.md part 3): its timeline, findings and log check, for its founder.
export default function InvestigateSession() {
  const { sid } = useParams();
  const { data: team } = useQuery({ queryKey: ["team"], queryFn: async () => (await api.get("/team")).data });
  const { data } = useQuery({ queryKey: ["investigation", sid], queryFn: async () => (await api.get(`/sessions/${sid}/investigation`)).data });
  const members = team?.members || [];
  const coder = members.find((m) => m.id === data?.session?.coder_id);
  const names = Object.fromEntries(members.map((m) => [m.id, m.name || m.email]));
  return <InvestigateTimeline sid={sid} audience="owner" back={{ to: "/founder/investigate", label: "Investigate" }}
    person={data && (coder ? coder.name || coder.email : "A former member")} names={names} />;
}
